document.addEventListener("DOMContentLoaded", () => {
  const formContainer = document.getElementById("home-contact-form-container");
  if (!formContainer) return;

  const form = document.getElementById("home-contact-form");
  const messagesDiv = document.getElementById("home-contact-form-messages");
  const loadingOverlay = document.getElementById(
    "home-contact-loading-overlay"
  );
  // Get input fields for validation
  const nameInput = form.querySelector('[name="name"]');
  const emailInput = form.querySelector('[name="email"]');
  const messageInput = form.querySelector('[name="message"]');

  if (
    !form ||
    !messagesDiv ||
    !loadingOverlay ||
    !nameInput ||
    !emailInput ||
    !messageInput
  ) {
    // console.warn("Contact form elements not found.");
    return;
  }

  const clearFieldErrors = () => {
    form
      .querySelectorAll(".form-field-error")
      .forEach((el) => (el.textContent = ""));
    form
      .querySelectorAll(".form-control.is-invalid")
      .forEach((el) => el.classList.remove("is-invalid"));
  };

  const displayMessage = (message, type = "error") => {
    messagesDiv.innerHTML = `<div class="alert alert-${type}">${message}</div>`;
    messagesDiv.style.display = "block";
    if (type === "error") {
      messagesDiv.setAttribute("aria-live", "assertive");
    } else {
      messagesDiv.setAttribute("aria-live", "polite");
    }
  };

  const displayFieldErrors = (errors) => {
    clearFieldErrors();
    for (const field in errors) {
      const errorEl = document.getElementById(`error-${field}`);
      const inputEl = form.querySelector(`[name="${field}"]`);
      if (errorEl) {
        errorEl.textContent = errors[field];
      }
      if (inputEl) {
        inputEl.classList.add("is-invalid");
      }
    }
  };

  const isValidEmail = (email) => {
    // Basic email validation regex
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  form.addEventListener("submit", async (event) => {
    event.preventDefault();
    clearFieldErrors();
    messagesDiv.style.display = "none";
    messagesDiv.innerHTML = "";

    // Frontend Validation
    const nameValue = nameInput.value.trim();
    const emailValue = emailInput.value.trim();
    const messageValue = messageInput.value.trim();
    const clientErrors = {};

    if (!nameValue) {
      clientErrors.name = "Adınız gereklidir.";
    }

    if (!emailValue) {
      clientErrors.email = "E-posta gereklidir.";
    } else if (!isValidEmail(emailValue)) {
      clientErrors.email = "Geçersiz e-posta formatı.";
    }

    if (!messageValue) {
      clientErrors.message = "Mesajınız gereklidir.";
    } else if (messageValue.length > 150) {
      clientErrors.message = "Mesajınız en fazla 150 karakter olmalıdır.";
    }

    if (Object.keys(clientErrors).length > 0) {
      displayFieldErrors(clientErrors);
      displayMessage("Lütfen formdaki hataları düzeltin.", "error");
      return; // Stop submission if client-side errors exist
    }

    loadingOverlay.style.display = "flex"; // Show loading overlay

    const formData = new FormData(form);
    formData.append("action", "submit_contact_form");
    // Nonce is already part of themeVariables.contactFormNonce, passed from PHP
    // but the wp_nonce_field in the form adds 'contact_form_nonce_field'
    // We need the actual nonce value for the 'nonce' key in POST.
    // The AJAX handler expects 'nonce' key.
    const nonceField = form.querySelector(
      'input[name="contact_form_nonce_field"]'
    );
    if (nonceField) {
      formData.append("nonce", nonceField.value);
    } else if (
      window.themeVariables &&
      window.themeVariables.contactFormNonce
    ) {
      // Fallback if the field isn't found, though it should be.
      formData.append("nonce", window.themeVariables.contactFormNonce);
    }

    try {
      const response = await fetch(
        window.themeVariables?.ajaxUrl || "/wp-admin/admin-ajax.php",
        {
          method: "POST",
          body: formData,
        }
      );

      const result = await response.json();

      if (response.ok && result.success) {
        form.style.display = "none"; // Hide the form
        displayMessage(result.data.message, "success");
        // Optionally, clear the form fields: form.reset();
        // Or remove the form container entirely if preferred
        // formContainer.innerHTML = `<div class="alert alert-success">${result.data.message}</div>`;
      } else {
        let errorMessage =
          result.data?.message || "Bilinmeyen bir hata oluştu."; // Turkish fallback
        if (result.data?.errors) {
          displayFieldErrors(result.data.errors);
          // Use the general message if available, otherwise a default one for field errors
          errorMessage =
            result.data.message || "Lütfen yukarıdaki hataları düzeltin."; // Turkish fallback
        }
        displayMessage(errorMessage, "error");
      }
    } catch (error) {
      //   console.error("Form submission error:", error);
      displayMessage(
        "Bir ağ hatası oluştu. Lütfen tekrar deneyin.", // Turkish fallback
        "error"
      );
    } finally {
      loadingOverlay.style.display = "none"; // Hide loading overlay
    }
  });
});
